import yaml from 'js-yaml'
export default yaml.load(`
- name: Mobile 
  value: mobile
- name: Web Application 
  value: webapp
- name: Conversational Interfaces
  value: conversational
- name: Assistive Tech
  value: assistive
- name: Big Data
  value: bigdata
- name: Computer Graphics
  value: "computer-graphics"
`)


/** WEBPACK FOOTER **
 ** ../data/work-categories.js
 **/